import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { CREATE_BET_HOUSE_PATH } from "../../utils/createBetHouseHelpers";

const OperatorNoHouseHero = () => (
  <header className="oc-hero oc-hero-dormant">
    <div className="oc-hero-copy">
      <p className="oc-eyebrow">House treasury</p>
      <h1>No house yet</h1>
      <span>
        Launch a betting house to track balance, fixtures, and live controls
        from this desk.
      </span>
    </div>

    <div className="oc-hero-dormant-ring" aria-hidden>
      <span className="oc-hero-dormant-ring-inner">—</span>
    </div>

    <div className="oc-hero-pools oc-hero-pools-dormant">
      <div>
        <em>Available</em>
        <strong className="tabular-nums">—</strong>
      </div>
      <div>
        <em>Locked</em>
        <strong className="tabular-nums">—</strong>
      </div>
      <div>
        <em>Pending</em>
        <strong className="tabular-nums">—</strong>
      </div>
    </div>

    <div className="oc-hero-actions">
      <Link to={CREATE_BET_HOUSE_PATH} className="oc-hero-action oc-create-house-btn">
        <Plus size={15} strokeWidth={2.25} aria-hidden />
        <span>Create a house</span>
      </Link>
    </div>
  </header>
);

export default OperatorNoHouseHero;
